import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { pushApi, type SendPromotionPayload } from '../api/push.api';

export function useSendPromotion() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: SendPromotionPayload) => pushApi.sendPromotion(data),
        onSuccess: (result) => {
            queryClient.invalidateQueries({ queryKey: ['push', 'scheduled-promotions'] });
            queryClient.invalidateQueries({ queryKey: ['push', 'promotion-history'] });
            notifications.show({
                title: 'Готово',
                message: result.message ?? 'Рассылка запущена. Отправка выполняется в фоне.',
                color: 'green',
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: 'Ошибка',
                message: error?.response?.data?.message || 'Не удалось отправить рассылку',
                color: 'red',
            });
        },
    });
}
